import { pull } from '../../../../node_modules/glo-shared-js/utils/helpers';

window.onboardingSelections = {
	outcomes: [], // array of strings
	styles: [], // array of id numbers
	teachers: [], // array of id numbers
	personalities: [], // array of id numbers
	priorExperiences: {
		'1': null, // 1 = yoga
		'3': null // 3 = pilates
	}
};

function addToSelections(type, item, modality) {
	var selection = window.onboardingSelections[type];

	if (type === 'priorExperiences') {
		selection[modality] = item;

		if (item === 0) {
			selection[modality] = null;
		}
	} else {
		if (isNaN(parseInt(item))) {
			selection.push(item);
		} else {
			selection.push(parseInt(item));
		}
	}
}

function removeFromSelections(type, item) {
	var selection = window.onboardingSelections[type];

	if (isNaN(parseInt(item))) {
		window.onboardingSelections[type] = pull(selection, item);
	} else {
		window.onboardingSelections[type] = pull(selection, parseInt(item));
	}
}

function removeAllSelections(type) {
	var selection = window.onboardingSelections[type];

	if (type === 'priorExperiences') {
		for (var key in selection) {
			selection[key] = null;
		}
	} else if (selection.length > 0) {
		selection.splice(0, selection.length);
	}
}

function resetAllSelections() {
	window.onboardingSelections = {
		outcomes: [],
		styles: [],
		teachers: [],
		personalities: [],
		priorExperiences: {
			'1': null,
			'3': null
		}
	};
}

export { addToSelections, removeFromSelections, removeAllSelections, resetAllSelections };
